// extracted by mini-css-extract-plugin
export var infoItem = "_th-2";
export var title = "_th-0";
export var value = "_th-1";